import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import FrequencyDistributionCategoryReportTabResultListViewModel from "./frequency-distribution-category-report-tab-result-list-view-model";
import FrequencyDistributionCategoryReportTabResultDiagramViewModel from "./frequency-distribution-category-report-tab-result-diagram-view-model";
import "./../../bindings/bao-tabs";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
function FrequencyDistributionCategoryReportViewModel(parent) {
    var self = this;
    self.parent = parent;
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.ReportLoaded = ko.observable(false);
    self.StartDateTime = ko.observable();
    self.EndDateTime = ko.observable();
    self.AreaId = ko.observable();
    self.AreaName = ko.observable();
    self.AreaEquipmentId = ko.observable();
    self.AreaEquipmentName = ko.observable();
    self.FilterMultiCategoryIds = ko.observableArray([]);
    self.FilterMultiCategoryItems = ko.observableArray([]);
    self.FilterMultiCategorysTextValue = ko.observable("");
    self.FilterMultiStateIds = ko.observableArray([]);
    self.FilterMultiStateItems = ko.observableArray([]);
    self.FilterMultiStatesTextValue = ko.observable("");
    self.FilterMultiCategory = {
        ObjectId: self.FilterMultiCategoryIds,
        ObjectValue: "CategoryFullName",
        SearchType: "CategoryStructure",
        AutoComplete: true,
        AutoCompleteOpts: {
            preselect: false
        },
        MultiSelect: true,
        Items: self.FilterMultiCategoryItems,
        AutoSearch: true
    };
    self.FilterMultiState = {
        ObjectId: self.FilterMultiStateIds,
        ObjectValue: "StateText",
        SearchType: "State",
        AutoComplete: true,
        MultiSelect: true,
        Items: self.FilterMultiStateItems,
        AutoSearch: true
    };
    self.AvailableLimits = ko.observableArray();
    self.Limit = ko.observable();
    self.TabViewModel = new TabController(false);
    self.Models = ko.observableArray([]);
    self.AllModels = ko.observableArray([]);
    self.PageIndexDefault = 0;
    self.PageSizeDefault = 10;
    self.PageIndex = ko.observable(self.PageIndexDefault);
    self.PageSize = ko.observable(self.PageSizeDefault);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observable([]);
    self.ResultTabList = null;
    self.ResultTabDiagram = null;
    self.CaptionDatasieriesname = ko.observable("data1");
    self.chartColors = [];
    self.DiagramDataSet = ko.pureComputed(function () {
        var entries = self.AllModels();
        var data = {
            x: "x",
            columns: [["data1"], ["x"]],
            types: {
                data1: "bar"
            },
            names: {
                data1: self.CaptionDatasieriesname()
            },
            labels: true,
            color: function (color, d) {
                if (d.index != null && self.chartColors != null) {
                    return self.chartColors[d.index];
                }
                return "#1f77b4";
            }
        };
        if (entries.length > 0) {
            for (var i in entries) {
                var y = ko.unwrap(entries[i].NumberOfEvents);
                if (typeof y === "undefined" || y === null) {
                    y = 0;
                }
                data.columns[0].push(y);
                var label = ko.unwrap(entries[i].CategoryFullName);
                if (typeof label === "undefined" || label === null) {
                    label = "";
                }
                data.columns[1].push(label);
                var color = ko.unwrap(entries[i].ColorString);
                if (typeof color === "undefined" || color == null) {
                    color = "#1f77b4";
                }
                self.chartColors.push(color);
            }
        }
        return data;
    });
    self.IsReportResultEmpty = ko.pureComputed(function () {
        return Boolean(self.ReportLoaded() && typeof self.Models() !== "undefined" && self.Models().length === 0);
    });
    self.PageIndex.subscribe(function () {
        if (self.Initialized() && self.ReportLoaded()) {
            parent.TabPage.IsLoading(true);
            self.RefreshModels().done(function () {
                self.ReportLoaded(true);
                parent.TabPage.IsLoading(false);
            });
        }
    });
    self.Sorting.subscribe(function () {
        if (self.Initialized() && self.ReportLoaded()) {
            parent.TabPage.IsLoading(true);
            $.when(self.RefreshModels(), self.RefreshDiagramModels()).done(function () {
                self.ReportLoaded(true);
                parent.TabPage.IsLoading(false);
            });
        }
    });
    self.Download = function () {
        if (!self.IsComplete()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("SelectOneTag"), "info");
            return;
        }
        if (!self.IsValidDateFields()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }
        var filterlist = ["StartDateTime", "EndDateTime", "AreaId", "AreaName", "AreaEquipmentId", "AreaEquipmentName", "FilterMultiCategorysTextValue", "FilterMultiStatesTextValue"];
        var filter = self.GetFilterHashObject(filterlist);
        filter.push({
            Key: "Limit",
            Value: 10
        });
        var data = {
            filter: filter,
            sorting: []
        };
        self.parent.DownloadReport("FrequencyDistributionCategoryReport", data);
    };
    self.GetFilterHashObject = function (filterlist) {
        var filter = self.parent.GetFilterHashObject(filterlist, self);
        filter.push({
            Key: "FilterMultiCategoryIds",
            Value: JSON.stringify(ko.unwrap(self.FilterMultiCategoryIds))
        });
        filter.push({
            Key: "FilterMultiStateIds",
            Value: JSON.stringify(ko.unwrap(self.FilterMultiStateIds))
        });
        return filter;
    };
    self.IsComplete = function () {
        return Boolean(!Bao.Utils.String.IsNullOrEmpty(self.StartDateTime()) && !Bao.Utils.String.IsNullOrEmpty(self.EndDateTime()));
    };
    self.IsValidDateFields = function () {
        return Boolean(Bao.Utils.String.IsNullOrEmpty(self.StartDateTime()) || Bao.Utils.String.IsNullOrEmpty(self.EndDateTime()) || Number(self.EndDateTime()) >= Number(self.StartDateTime()));
    };
    self.GetFrequencyDistributionCategoryReportResult = function (sorting, pageIndex, pageSize, saveFilter) {
        var filterlist = ["StartDateTime", "EndDateTime", "AreaId", "AreaName", "AreaEquipmentId", "AreaEquipmentName", "Limit", "FilterMultiCategorysTextValue", "FilterMultiStatesTextValue"];
        var filter = self.GetFilterHashObject(filterlist);
        if (saveFilter === true) {
            self.parent.SaveFilter(filter, sorting, 0);
        }
        self.chartColors = [];
        return Bao.post("ReportCenter/FrequencyDistributionCategoryGetReportResult", JSON.stringify({
            filter: filter,
            sorting: sorting,
            pageIndex: pageIndex,
            pageSize: pageSize
        }));
    };
    self.RefreshModels = function () {
        return self.GetFrequencyDistributionCategoryReportResult(self.Sorting(), self.PageIndex(), self.PageSize(), true).done(function (result) {
            if (result.Result == true) {
                self.Models(result.Models);
                self.TotalRows(result.TotalRows);
            }
        });
    };
    self.RefreshDiagramModels = function () {
        return self.GetFrequencyDistributionCategoryReportResult(self.Sorting(), 0, 0).done(function (result) {
            if (result.Result == true) {
                self.AllModels(result.Models);
            }
        });
    };
    self.resetDefaults = function () {
        self.ReportLoaded(false);
        self.Models([]);
        self.AllModels([]);
        self.PageIndex(self.PageIndexDefault);
        self.PageSize(self.PageSizeDefault);
        self.TotalRows(0);
        self.Sorting([]);
    };
    self.Display = function () {
        if (!self.IsComplete()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("SelectOneTag"), "info");
            return;
        }
        if (!self.IsValidDateFields()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }
        parent.TabPage.IsLoading(true);
        self.resetDefaults();
        self.TabViewModel.SelectTab(self.ResultTabList);
        self.RefreshModels().done(function () {
            self.RefreshDiagramModels().done(function () {
                self.ReportLoaded(true);
                parent.TabPage.IsLoading(false);
            }).fail(function () {
                self.ReportLoaded(false);
                parent.TabPage.IsLoading(false);
            });
        }).fail(function () {
            self.ReportLoaded(false);
            parent.TabPage.IsLoading(false);
        });
    };
    self.getFrequencyDistributionCategoryReportModel = function () {
        return Bao.post("ReportCenter/FrequencyDistributionCategoryGetReportModel", JSON.stringify({}));
    };
    self.init = function () {
        var def = $.Deferred();
        self.getFrequencyDistributionCategoryReportModel().done(function (result) {
            ko.map.fromJS(result, self);
            if (result.FilterMultiCategoryIds) {
                var deserialize = ko.utils.parseJson(result.FilterMultiCategoryIds);
                var deserializeSecond = ko.utils.parseJson(deserialize);
                if (deserializeSecond == null) {
                    self.FilterMultiCategoryIds(deserialize);
                }
                else {
                    self.FilterMultiCategoryIds(deserializeSecond);
                }
            }
            if (result.FilterMultiStateIds) {
                var deserialize = ko.utils.parseJson(result.FilterMultiStateIds);
                var deserializeSecond = ko.utils.parseJson(deserialize);
                if (deserializeSecond == null) {
                    self.FilterMultiStateIds(deserialize);
                }
                else {
                    self.FilterMultiStateIds(deserializeSecond);
                }
            }
            def.resolve();
        });
        def.done(function () {
            self.Initialized(true);
        });
        return def.promise();
    };
    self.loaded = function () {
        self.ResultTabList = new TabPage(null);
        self.ResultTabList.Url("ReportCenter/FrequencyDistributionCategoryReportTabResultList");
        self.ResultTabList.AutoSelect = true;
        self.ResultTabList.IsClosable(false);
        self.ResultTabList.PreLoad(true);
        self.ResultTabList.Visible(true);
        self.ResultTabList.ViewModel(new FrequencyDistributionCategoryReportTabResultListViewModel(self.TabPage, self));
        self.ResultTabList.Bao = Bao;
        self.TabViewModel.AddTab(self.ResultTabList);
        self.ResultTabDiagram = new TabPage(null);
        self.ResultTabDiagram.Url("ReportCenter/FrequencyDistributionCategoryReportTabResultDiagram");
        self.ResultTabDiagram.AutoSelect = false;
        self.ResultTabDiagram.IsClosable(false);
        self.ResultTabDiagram.PreLoad(true);
        self.ResultTabDiagram.Visible(true);
        self.ResultTabDiagram.ViewModel(new FrequencyDistributionCategoryReportTabResultDiagramViewModel(self.TabPage, self.DiagramDataSet, self.DiagramTicks));
        self.ResultTabDiagram.Bao = Bao;
        self.TabViewModel.AddTab(self.ResultTabDiagram);
    };
}
export default FrequencyDistributionCategoryReportViewModel;